/**
 *
 * @param {"muted" | "info" | "danger"| "warning" | "success" } type
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
const FormFeedback = ({ type, children }) => {
  return <div className={`feedback text-${type}`}>{children}</div>;
};

export default FormFeedback;
